export const rubros =[
	{
		//"url":"Transparencia.html?ver=Normatividad",
	    "icono":"Normatividad.png",
	    "nombre":"1.Normatividad",
	    "formatos":[
	    	{
	    		"nombre":"Marco Normativo",
	    		"xlsx":"f01",
	    		"html":"f01",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Estructura",
	    "icono":"Estructura.png",
	    "nombre":"2.Estructura",
	    "formatos":[
	    	{
	    		"nombre":"Estructura Orgánica",
	    		"xlsx":"f02_a",
	    		"html":"f02_a",
	    	},
	    	{
	    		"nombre":"Organigrama",
	    		"xlsx":"f02_b",
	    		"html":"f02_b",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Facultades",
	    "icono":"Facultades.png",
	    "nombre":"3.Facultades",
	    "formatos":[
	    	{
	    		"nombre":"Facultades",
	    		"xlsx":"f03",
	    		"html":"f03",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Programas_Operativos_Anuales",
	    "icono":"ProgramasOperativosAnuales.png",
	    "nombre":"4.Programas Operativos Anuales",
	    "formatos":[
	    	{
	    		"nombre":"Metas y Objetivos",
	    		"xlsx":"f04",
	    		"html":"f04",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Indicadores_de_Interes",
	    "icono":"IndicadoresInteres.png",
	    "nombre":"5.Indicadores de Interés",
	    "formatos":[
	    	{
	    		"nombre":"Indicadores de Interés",
	    		"xlsx":"f05",
	    		"html":"f05",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Matriz_de_Indicadores",
	    "icono":"MatrizIndicadores.png",
	    "nombre":"6.Matriz de Indicadores",
	    "formatos":[
	    	{
	    		"nombre":"Matriz de Indicadores",
	    		"xlsx":"f06",
	    		"html":"f06",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Directorio",
	    "icono":"Directorio.png",
	    "nombre":"7.Directorio",
	    "formatos":[
	    	{
	    		"nombre":"Directorio",
	    		"xlsx":"f07",
	    		"html":"f07",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Sueldos",
	    "icono":"Sueldos.png",
	    "nombre":"8.Sueldos",
	    "formatos":[
	    	{
	    		"nombre":"Remuneraciones brutas y netas",
	    		"xlsx":"f08_a",
	    		"html":"f08_a",
	    	},
	    	{
	    		"nombre":"Tabulador de sueldos y salarios",
	    		"xlsx":"f08_b",
	    		"html":"f08_b",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Viaticos",
	    "icono":"Viaticos.png",
	    "nombre":"9.Viáticos",
	    "formatos":[
	    	{
	    		"nombre":"Viáticos",
	    		"xlsx":"f09",
	    		"html":"f09",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Plazas",
	    "icono":"Plazas.png",
	    "nombre":"10.Plazas",
	    "formatos":[
	    	{
	    		"nombre":"Total de Personal de Base y Confianza",
	    		"xlsx":"f10_a",
	    		"html":"f10_a",
	    	},
	    	{
	    		"nombre":"Total de las Plazas de Base y Confianza",
	    		"xlsx":"f10_b",
	    		"html":"f10_b",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Honorarios",
	    "icono":"Honorarios.png",
	    "nombre":"11.Honorarios",
	    "formatos":[
	    	{
	    		"nombre":"Personal de Honorarios",
	    		"xlsx":"f11",
	    		"html":"f11",
	    	}
	    ]
	},
	{    
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%Bablicas",
	    "icono":"DeclaracionesPublicas.png",
	    "nombre":"12.Declaraciones Públicas",
	    "formatos":[
	    	{
	    		"nombre":"Declaraciones Patrimoniales",
	    		"xlsx":"f12",
	    		"html":"f12",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad",
	    "icono":"DatosContactoUnidad.png",
	    "nombre":"13.Datos de contacto de la Unidad",
	    "formatos":[
	    	{
	    		"nombre":"Domicilio de la Unidad de Transparencia",
	    		"xlsx":"f13",
	    		"html":"f13",
	    	}
	    ]
	},
	{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/14.%20Convocatorias",
	    "icono":"Convocatorias.png",
	    "nombre":"14.Convocatorias",
	    "formatos":[
	    	{
	    		"nombre":"Convocatorias a Concursos para Cargos Públicos",
	    		"xlsx":"f14",
	    		"html":"f14",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Programas_Sociales",
	    "icono":"ProgramasSociales.png",
	    "nombre":"15.Programas Sociales",
	    "formatos":[
	    	{
	    		"nombre":"Programas de Subsidio, Estímulo y Apoyo",
	    		"xlsx":"f15_a",
	    		"html":"f15_a",
	    	},
	    	{
	    		"nombre":"Padrón de beneficiarios",
	    		"xlsx":"f15_b",
	    		"html":"f15_b",
	    	}
	    ]
	},
	{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/16.%20Relaciones%20Laborales",
	    "icono":"RelacionesLaborales.png",
	    "nombre":"16.Relaciones Laborales",
	    "formatos":[
	    	{
	    		"nombre":"Condiciones Generales de Trabajo",
	    		"xlsx":"f16_a",
	    		"html":"f16_a",
	    	},
	    	{
	    		"nombre":"Recursos Públicos",
	    		"xlsx":"f16_b",
	    		"html":"f16_b",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Informacion_Curricular",
	    "icono":"InformacionCurricular.png",
	    "nombre":"17.Informacion Curricular",
	    "formatos":[
	    	{
	    		"nombre":"Información Curricular",
	    		"xlsx":"f17",
	    		"html":"f17",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas",
	    "icono":"SancionesAdministrativas.png",
	    "nombre":"18.Sanciones Administrativas",
	    "formatos":[
	    	{
	    		"nombre":"Servidores Públicos Sancionados",
	    		"xlsx":"f18",
	    		"html":"f18",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Servicios",
	    "icono":"Servicios.png",
	    "nombre":"19.Servicios",
	    "formatos":[
	    	{
	    		"nombre":"Servicios",
	    		"xlsx":"f19",
	    		"html":"f19",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Tramites",
	    "icono":"Tramites.png",
	    "nombre":"20.Trámites",
	    "formatos":[
	    	{
	    		"nombre":"Trámites",
	    		"xlsx":"f20",
	    		"html":"f20",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Presupuesto_e_Informes_Semestrales",
	    "icono":"PresupuestoInformesTrimestrales.png",
	    "nombre":"21.Presupuesto e Informes Trimestrales",
	    "formatos":[
	    	{
	    		"nombre":"Presupuesto Anual",
	    		"xlsx":"f21_a",
	    		"html":"f21_a",
	    	},
	    	{
	    		"nombre":"Gasto trimestral",
	    		"xlsx":"f21_b",
	    		"html":"f21_b",
	    	},
	    	{
	    		"nombre":"Cuenta Pública",
	    		"xlsx":"f21_c",
	    		"html":"f21_c",
	    	}
	    ]
	},
	{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%Bablica",
	    "icono":"DeudaPublica.png",
	    "nombre":"22.Deuda Pública",
	    "formatos":[
	    	{
	    		"nombre":"Deuda Pública",
	    		"xlsx":"f22",
	    		"html":"f22",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Comunicacion_Social_y_Publicidad",
	    "icono":"ComunicacionSocialPublicidad.png",
	    "nombre":"23.Comunicación Social y Publicidad",
	    "formatos":[
	    	{
	    		"nombre":"Programa Anual de Comunicación Social",
	    		"xlsx":"f23_a",
	    		"html":"f23_a",
	    	},
	    	{
	    		"nombre":"Erogación de Recursos de Comunicación Social",
	    		"xlsx":"f23_b",
	    		"html":"f23_b",
	    	},
	    	{  
	
	    		"nombre":"Tiempos Oficiales",
	    		"xlsx":"f23_c",
	    		"html":"f23_c",
	    		"xlsx_liga" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx",
	    		"htm_liga" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm"
	    	}
	    	//{   
	    	//	"nombre":"Información Relacionada a Tiempos Oficiales",
	    	//	"xlsx":"f23_d",
	    	//	"html":"f23_d",
	    	//	"xlsx_liga" : "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2024/Transparencia/2doTrim/xlsx/a69_f23_d_RTH.xlsx",
	    	//	"htm_liga" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/2023/Transparencia/htm/a69_f23_d_RTVH.htm"
	    	//}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%Adas",
	    "icono":"ResultadosAuditorias.png",
	    "nombre":"24.Resultados de Auditorías",
	    "formatos":[
	    	{
	    		"nombre":"Auditorías",
	    		"xlsx":"f24",
	    		"html":"f24",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Dictamenes_de_Estados_Financieros",
	    "icono":"DictamenesFinancieros.png",
	    "nombre":"25.Dictámenes de Estados Financieros",
	    "formatos":[
	    	{
	    		"nombre":"Estados Financieros",
	    		"xlsx":"f25",
	    		"html":"f25",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Asignacion_de_Recursos_Publicos_a_Personas",
	    "icono":"AsignacionRecursosPublicosPersonas.png",
	    "nombre":"26.Asignación de Recursos Públicos a Personas",
	    "formatos":[
	    	{
	    		"nombre":"Personas a Quienes se asignó Recursos Públicos",
	    		"xlsx":"f26",
	    		"html":"f26",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Concesiones",
	    "icono":"Concesiones.png",
	    "nombre":"27.Concesiones",
	    "formatos":[
	    	{
	    		"nombre":"Concesiones, Contratos, Convenios, Permisos, Licencias y Autorizaciones",
	    		"xlsx":"f27",
	    		"html":"f27",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Licitaciones_Publicas",
	    "icono":"LicitacionesPublicas.png",
	    "nombre":"28.Licitaciones Públicas",
	    "formatos":[
	    	{
	    		"nombre":"Resultados de procedimientos de adjudicación directa, licitación pública e invitación restringida",
	    		"xlsx":"f28",
	    		"html":"f28",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Informes",
	    "icono":"Informes.png",
	    "nombre":"29.Informes",
	    "formatos":[
	    	{
	    		"nombre":"Informes",
	    		"xlsx":"f29",
	    		"html":"f29",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Estadisticas_Generales",
	    "icono":"EstadisticasGenerales.png",
	    "nombre":"30.Estadísticas Generadas",
	    "formatos":[
	    	{
	    		"nombre":"Estadísticas",
	    		"xlsx":"f30",
	    		"html":"f30",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Informe_de_Avances_y_Documentos_Financieros",
	    "icono":"InformeAvancesDocumentosFinancieros.png",
	    "nombre":"31.Informe de Avances y Documentos Financieros",
	    "formatos":[
	    	{
	    		"nombre":"Informe de Estados Financieros",
	    		"xlsx":"f31_a",
	    		"html":"f31_a",
	    	},
	    	{
	    		"nombre":"Informe Contable, Presupuestal y Programático",
	    		"xlsx":"f31_b",
	    		"html":"f31_b",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas",
	    "icono":"PadronProveedoresContratistas.png",
	    "nombre":"32.Padrón de Proveedores y Contratistas",
	    "formatos":[
	    	{
	    		"nombre":"Padrón de Proveedores y Contratistas",
	    		"xlsx":"f32",
	    		"html":"f32",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Convenios_con_Sectores_Social_y_Privados",
	    "icono":"ConveniosSectoresSocialPrivado.png",
	    "nombre":"33.Convenios con Sectores Social y Privados",
	    "formatos":[
	    	{
	    		"nombre":"Convenios de Coordinación y Concertación",
	    		"xlsx":"f33",
	    		"html":"f33",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Inventario_de_Bienes",
	    "icono":"InventarioBienes.png",
	    "nombre":"34.Inventario de Bienes",
	    "formatos":[
	    	{
	    		"nombre":"Inventario de Bienes Muebles",
	    		"xlsx":"f34_a",
	    		"html":"f34_a",
	    	},
	    	{
	    		"nombre":"Alta de Bienes Muebles",
	    		"xlsx":"f34_b",
	    		"html":"f34_b",
	    	},
	    	{
	    		"nombre":"Bajas de Bienes Muebles",
	    		"xlsx":"f34_c",
	    		"html":"f34_c",
	    	},
	    	{
	    		"nombre":"Inventario de Bienes Inmuebles",
	    		"xlsx":"f34_d",
	    		"html":"f34_d",
	    	},
	    	{
	    		"nombre":"Alta de Bienes Inmuebles",
	    		"xlsx":"f34_e",
	    		"html":"f34_e",
	    	},
	    	{
	    		"nombre":"Bajas de Bienes Inmuebles",
	    		"xlsx":"f34_f",
	    		"html":"f34_f",
	    	},
	    	{
	    		"nombre":"Donaciones de Bienes Muebles e Inmuebles",
	    		"xlsx":"f34_g",
	    		"html":"f34_g",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Recomendaciones_y_Atencion_en_Materia_de_Derechos_Humanos",
	    "icono":"RecomendacionesAtenciónMateriaDerechosHumanos.png",
	    "nombre":"35.Recomendaciones y Atención en Materia de Derechos Humanos",
	    "formatos":[
	    	{
	    		"nombre":"Recomendaciones de Derechos Humanos Emitidas por la CNDH",
	    		"xlsx":"f35_a",
	    		"html":"f35_a",
	    	},
	    	{
	    		"nombre":"Recomendaciones de Derechos Humanos Casos Especiales",
	    		"xlsx":"f35_b",
	    		"html":"f35_b",
	    	},
	    	{
	    		"nombre":"Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
	    		"xlsx":"f35_c",
	    		"html":"f35_c",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/36.%20Resoluciones%20y%20Laudos%20de%20Juicios",
	    "icono":"ResolucionesLaudosJuicios.png",
	    "nombre":"36.Resoluciones y Laudos de Juicios",
	    "formatos":[
	    	{
	    		"nombre":"Resoluciones y Laudos",
	    		"xlsx":"f36",
	    		"html":"f36",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Mecanismos_de_Participacion_Ciudadana",
	    "icono":"MecanismosParticipacionCiudadana.png",
	    "nombre":"37.Mecanismos de Participación Ciudadana",
	    "formatos":[
	    	{
	    		"nombre":"Mecanismos de Participación Ciudadana",
	    		"xlsx":"f37_a",
	    		"html":"f37_a",
	    	},
	    	{
	    		"nombre":"Resultados de los Mecanismos de Participación Ciudadana",
	    		"xlsx":"f37_b",
	    		"html":"f37_b",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Programas_Ofrecidos",
	    "icono":"ProgramasOfrecidos.png",
	    "nombre":"38.Programas Ofrecidos",
	    "formatos":[
	    	{
	    		"nombre":"Programas que Ofrecen",
	    		"xlsx":"f38_a",
	    		"html":"f38_a",
	    	},
	    	{
	    		"nombre":"Tramites a los Programas que Ofrecen",
	    		"xlsx":"f38_b",
	    		"html":"f38_b",
	    	}
	    ]
	},
	{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia",
	    "icono":"ActasResolucionesComiteTransparencia.png",
	    "nombre":"39.Actas y Resoluciones del Comité de Transparencia",
	    "formatos":[
	    	{
	    		"nombre":"Informe de Sesiones",
	    		"xlsx":"f39_a",
	    		"html":"f39_a",
	    	},
	    	{
	    		"nombre":"Informe de Resoluciones",
	    		"xlsx":"f39_b",
	    		"html":"f39_b",
	    	},
	    	{
	    		"nombre":"Actas Integrantes del Comité",
	    		"xlsx":"f39_c",
	    		"html":"f39_c",
	    	},
	    	{
	    		"nombre":"Calendario de Sesiones del comité",
	    		"xlsx":"f39_d",
	    		"html":"f39_d",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Evaluacion_y_Encuestas_a_Programas_Financiados_con_Recursos_Publicos",
	    "icono":"EvaluacionencuestasProgramas.png",
	    "nombre":"40.Evaluación y Encuestas a Programas Financiados con Recursos Públicos",
	    "formatos":[
	    	{
	    		"nombre":"Evaluaciones y encuestas a programas financiados con recursos públicos",
	    		"xlsx":"f40",
	    		"html":"f40",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Estudios_Pagados_con_Recursos_Publicos",
	    "icono":"EstudiosPagadosRecursosPublicos.png",
	    "nombre":"41.Estudios Pagados con Recursos Públicos",
	    "formatos":[
	    	{
	    		"nombre":"Estudios Pagados con Recursos Públicos",
	    		"xlsx":"f41",
	    		"html":"f41",
	    	}
	    ]
	},
	{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/42.%20Listados%20Jubilados%20y%20Pensionados",
	    "icono":"ListadoJubiladosPencionados.png",
	    "nombre":"42.Listado de Jubilados y Pensionados",
	    "formatos":[
	    	{
	    		"nombre":"Jubilados y Pensionados Leyenda",
	    		"xlsx":"f42_a",
	    		"html":"f42_a",
	    	},
	    	{
	    		"nombre":"Jubilados y Pensionados Listado",
	    		"xlsx":"f42_b",
	    		"html":"f42_b",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Ingresos_Recibidos_por_Cualquier_Concepto",
	    "icono":"IngresosRecibidosCualquierConcepto.png",
	    "nombre":"43.Ingresos Recibidos por Cualquier Concepto",
	    "formatos":[
	    	{
	    		"nombre":"Ingresos Recibidos",
	    		"xlsx":"f43_a",
	    		"html":"f43_a",
	    	},
	    	{
	    		"nombre":"Responsables de Recibir los Ingresos",
	    		"xlsx":"f43_b",
	    		"html":"f43_b",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Donaciones_Hechas_a_Terceros",
	    "icono":"DonacionesHechasTerceros.png",
	    "nombre":"44.Donaciones Hechas a Terceros",
	    "formatos":[
	    	{
	    		"nombre":"Donaciones en dinero y en especie realizadas",
	    		"xlsx":"f44",
	    		"html":"f44",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Catalogo_Documental_y_Guia_de_Archivos",
	    "icono":"CatalogoDocumentalGuiaArchivos.png",
	    "nombre":"45.Catálogo Documental y Guía de Archivos",
	    "formatos":[
	    	{
	    		"nombre":"Inventarios documentales",
	    		"xlsx":"f45_a",
	    		"html":"f45_a",
	    	},
	    	{
	    		"nombre":"Índice de expedientes clasificados como reservados",
	    		"xlsx":"f45_b", 
	    		"html":"f45_b",
	    		"xlsx_liga" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f45b_SC.xlsx",
	    		"htm_liga" : "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm"
	    	},
	    	{
	    		"nombre":"Cuadro general de clasificación archivística, Catálogo de disposición documental, Guía de archivo documental, Programa Anual de Desarrollo Archivístico, Informe Anual de cumplimiento, Actas y dictámenes de baja documental",
	    		"xlsx":"f45_c",
	    		"html":"f45_c",
	    	}
	    ]
	},
	{
		"url":"https://s-turismo.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/46.Actas%20de%20Sesiones,%20Opiniones%20y%20Recomendaciones%20de%20Consejos%20Consultivos",
	    "icono":"ActasSesionesOpinionesRecomendacionesConsejosConsultivos.png",
	    "nombre":"46.Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos",
	    "formatos":[
	    	{
	    		"nombre":"Actas del Consejo Consultivo Ciudadano",
	    		"xlsx":"f46_a",
	    		"html":"f46_a",
	    		"xlsx_liga" : "https://s-turismo.hidalgo.gob.mx/Transparencia/xlsx/a69_f46_a_SECTURH.xlsx",
	    		"htm_liga" : "https://s-turismo.hidalgo.gob.mx/Transparencia/htm/a69_f46_a_SECTURH.htm"
	    	},
	    	{
	    		"nombre":"Opiniones del Consejo Consultivo Ciudadano",
	    		"xlsx":"f46_b",
	    		"html":"f46_b",
	    		"xlsx_liga" : "https://s-turismo.hidalgo.gob.mx/Transparencia/xlsx/a69_f46_b_SECTURH.xlsx",
	    		"htm_liga" : "https://s-turismo.hidalgo.gob.mx/Transparencia/htm/a69_f46_b_SECTURH.htm"
	    	}
	    ]
	},
	{
		"url":"https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervenci%C3%B3n%20de%20%20Comunicaciones",
	    "icono":"SolicitudIntervencionComunicaciones.png",
	    "nombre":"47.Solicitud de Intervencion de Comunicaciones",
	    "formatos":[
	    	{
	    		"nombre":"Intervenciones de comunicaciones",
	    		"xlsx":"f47_a",
	    		"html":"f47_a",
	    	},
	    	{
	    		"nombre":"Localización Geográfica",
	    		"xlsx":"f47_b",
	    		"html":"f47_b",
	    	},
	    	{
	    		"nombre":"Mensaje de Solicitudes a empresas para la intervención de comunicaciones privadas",
	    		"xlsx":"f47_c",
	    		"html":"f47_c",
	    	}
	    ]
	},
	{
		//"url":"Transparencia.html?ver=Informacion_de_Utilidad_o_Relevante",
	    "icono":"InformacionUtilidadRelevante.png",
	    "nombre":"48.Información de Utilidad o Relevante",
	    "formatos":[
	    	{
	    		"nombre":"Interés Público",
	    		"xlsx":"f48_a",
	    		"html":"f48_a",
	    	},
	    	{
	    		"nombre":"Preguntas Frecuentes",
	    		"xlsx":"f48_b",
	    		"html":"f48_b",
	    	},
	    	{
	    		"nombre":"Transparencia Proactiva",
	    		"xlsx":"f48_c",
	    		"html":"f48_c",
	    	}
	    ]
	}
]